import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "cms-card-block"
};
const _hoisted_2 = {
  class: "mg-b--25",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  key: 0
};
import Buttons from '@/components/Buttons/index.vue';
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import { RELEASE_STATUS_NEW, paymentFormList } from '@/assets/config/dicts';
import { usePageConfig } from '@/utils/useComponentConfig';
import { inject, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { debounce } from '@/utils/tools';
import { elMessage } from '@/utils';
import { messageBox } from '@/utils/validate';
import { paymentSettingApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'PaidContent',
  props: {
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const selectTableRef = ref(null);
    const headerConfig = ref({
      title: '影片付费编辑',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const selectTableData = ref([]);
    const copySelectList = ref([]);
    const genresList = inject('genresList');

    const formateSelectData = () => {
      const selectTableConfig = inject('selectTableConfig');
      selectTableData.value = JSON.parse(JSON.stringify(selectTableConfig.selectData.filter(item => item.programType !== 11)));
      copySelectList.value = JSON.parse(JSON.stringify(selectTableConfig.selectData.filter(item => item.programType !== 11)));
    };

    const tableConfig = reactive({
      data: [],
      config: {
        loading: true
      },
      isCardBlock: false,
      isShowHeader: false,
      scrollbarAlwaysOn: true,
      paginationConfig: usePageConfig(),
      headerButtonsList: [{
        label: '免费',
        func: () => {
          changeSelectPaymentForm('free');
        }
      }, {
        label: 'VIP内容',
        func: () => {
          changeSelectPaymentForm('vip');
        }
      }, {
        label: '付费单片',
        func: () => {
          const idx = selectTableData.value.findIndex(item => item.programType === 1);

          if (idx > -1) {
            elMessage('warning', '选中剧集内容不支持设置为付费单片');
          } else {
            changeSelectPaymentForm('single_pay');
          }
        }
      }],
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, // { label: '序号', prop: '', type: 'index' },
      {
        label: '排序',
        prop: 'sequence',
        width: 100
      }, {
        label: 'IMDB ID',
        prop: 'programId',
        width: 120,
        sortable: 'custom'
      }, {
        label: '内容类型',
        prop: 'programType',
        width: 150,
        sortable: 'custom',
        formatter: value => {
          return value == 'tv_series' ? t('剧集') : value == 'movie' ? t('单片') : value == 'video_series' ? t('系列片') : '';
        }
      }, {
        label: '内容名称',
        prop: 'programName',
        width: 300,
        sortable: 'custom'
      }, {
        label: '付费形式',
        prop: 'paymentForm',
        cellSlot: true,
        width: 200,
        sortable: 'custom'
      }, {
        label: '分类属性',
        prop: 'genres',
        width: 220,
        sortable: 'custom' // formatter: (value: any) => {
        //   return formateStr(value, genresList.value)
        // }

      }, {
        label: '语言',
        prop: 'mediaContentLanguage',
        width: 200,
        sortable: 'custom'
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        width: 150,
        sortable: 'custom',
        formatter: value => {
          if (value !== undefined && value !== null) return RELEASE_STATUS_NEW[value];
        }
      }, {
        label: '分辨率',
        prop: 'resolution',
        width: 200,
        sortable: 'custom'
      }],
      'row-key': row => {
        return row.id;
      }
    });

    const handleSelectionChange = val => {
      selectTableData.value = val.map(item => item);
    }; // 批量更改选中付费设置


    const changeSelectPaymentForm = type => {
      selectTableData.value.forEach(item => {
        item.paymentForm = type;
        copySelectList.value.forEach(selectItem => {
          if (selectItem.id === item.id) {
            selectItem.paymentForm = type;
          }
        });
      });
      returnAllPageFunc();
    }; // 付费设置下拉选中事件


    const onPaymentFormChange = (id, value) => {
      const changeItem = selectTableData.value.find(item => item.id === id);
      changeItem.paymentForm = value;
    };

    const onConfirm = () => {
      if (selectTableData.value.length === 0) {
        elMessage('warning', '请选择至少一条数据');
      } else {
        messageBox('确定修改所选数据吗?').then(async () => {
          let dataArr = selectTableData.value.map(item => {
            return {
              id: item.id,
              payment: item.paymentForm
            };
          });

          try {
            const res = await paymentSettingApi(dataArr);

            if (res.code == '0') {
              elMessage('success', '修改成功');
              props.returnBackFn();
            }
          } catch (error) {}
        });
      }
    };

    const pcompare = (prop, rev) => {
      // 第二个参数没有传递，默认升序排序
      if (rev === undefined) {
        rev = -1;
      } else {
        rev = rev == 'desc' ? 1 : -1;
      }

      return function (obj1, obj2) {
        let val1 = obj1[prop],
            val2 = obj2[prop];
        return val1 < val2 ? rev * -1 : rev * 1;
      };
    };

    const returnAllPageFunc = async () => {
      tableConfig.config.loading = true;
      let newArr = JSON.parse(JSON.stringify(copySelectList.value));
      tableConfig.data = newArr.splice((tableConfig.paginationConfig.page - 1) * tableConfig.paginationConfig.limit, tableConfig.paginationConfig.limit);

      if (sortParams.sortField && sortParams.sortType) {
        tableConfig.data.sort(pcompare(sortParams.sortField, sortParams.sortType));
      }

      tableConfig.paginationConfig.total = copySelectList.value.length;
      setTimeout(() => {
        tableConfig.config.loading = false;
      }, 200);
    };

    const sortParams = reactive({
      sortType: '',
      sortField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        returnAllPageFunc();
      } else {
        sortParams.sortType = '';
        sortParams.sortField = '';
        returnAllPageFunc();
      }
    }, 200);
    onMounted(() => {
      formateSelectData();
      nextTick(() => {
        returnAllPageFunc();
        selectTableData.value.forEach(row => {
          selectTableRef.value.commonTableRef.toggleRowSelection(row, true);
        });
      });
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        selectTableRef.value && selectTableRef.value.commonTableRef.doLayout();
      });
    };

    return (_ctx, _cache) => {
      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_ButtomBtns = _resolveComponent("ButtomBtns");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Buttons, {
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_TableColumnOptionBtn, {
        "column-list": tableConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])]), _createVNode(_component_common_table, {
        ref_key: "selectTableRef",
        ref: selectTableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.config,
        onSelectionChange: handleSelectionChange,
        render: returnAllPageFunc,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'paymentForm' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_select, {
            onChange: value => onPaymentFormChange(scope.row.id, value),
            modelValue: scope.row.paymentForm,
            "onUpdate:modelValue": $event => scope.row.paymentForm = $event,
            class: "m-2",
            placeholder: "Select",
            size: "large"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentFormList), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "options", "onSortChange"]), _createVNode(_component_ButtomBtns, {
        onOnCancel: _cache[0] || (_cache[0] = $event => __props.returnBackFn()),
        onOnConfirm: onConfirm
      })])]);
    };
  }

});